import { render, staticRenderFns } from "./ItemDataAmazon.vue?vue&type=template&id=0cff46d2&scoped=true&"
import script from "./ItemDataAmazon.vue?vue&type=script&lang=js&"
export * from "./ItemDataAmazon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff46d2",
  null
  
)

export default component.exports